import React from 'react';

const HomePage: React.FC = () => {
  return (
    <div>
      <h1>Welcome to Chess Game!</h1>
      <nav>
        <ul>
          <li><a href="/login">Login</a></li>
          <li><a href="/register">Register</a></li>
        </ul>
      </nav>
      <p>Start game against bot (not implemented yet)</p>
      <p>Start game against another player (not implemented yet)</p>
    </div>
  );
};

export default HomePage;
